import moment from "moment-timezone";
import React, { useRef, useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { fireNotify } from "../../utils/utils";
import { __ } from '@wordpress/i18n';

let hsSyncingTimer = 4 * 500;
// hsSyncingTimer =500;
let hiveMessageCount = 0;

let GetAiInit = 1;

const ChatBox = () => {

  let homeTabSettings = {};
  if (hive_front.home_tab) {
    const cleanedString = hive_front.home_tab.replace(/\\+/g, "");
    const settingsObject = JSON.parse(cleanedString);
    homeTabSettings = settingsObject;
  }
  
  if (homeTabSettings && homeTabSettings.enable_chat_widget == false) return;

  let enableAiChat = true;
  let enableMessaging = true;
  let enableHelp = true;

  let messagingTabSettings = {};
  if (hive_front.messaging_tab) {
    const cleanedString = hive_front.messaging_tab.replace(/\\+/g, "");
    const settingsObject = JSON.parse(cleanedString);
    messagingTabSettings = settingsObject;
    if (messagingTabSettings.enable_live_messaging == false)
      enableMessaging = false;
  }

  let helpTabSettings = {};
  if (hive_front.help_tab) {
    const cleanedString = hive_front.help_tab.replace(/\\+/g, "");
    const settingsObject = JSON.parse(cleanedString);
    helpTabSettings = settingsObject;
    if (helpTabSettings.enable_help_tab == false) enableHelp = false;
  }

  let aiTabSettings = {};
  if (hive_front.ai_tab) {
    aiTabSettings = hive_front.ai_tab;
    if (aiTabSettings.enable_ai_chat == false) enableAiChat = false;
  }

  // Disable chat window for admins and agents
  if (hive_front.hive_agent == "yes") return;
  const $faqs = [
    {
      question: "How to purchase Hive Support Plugin?",
      answer: "Please, Buy from our official site",
    },
    {
      question: "I want to talk with a real person.",
      answer: "An active agent will connect to you soon.",
    },
    {
      question: "I need help with this Guidant Plugin.",
      answer:
        "Please, see the documentation and tutorials from the links below.",
    },
    {
      question: "Send me link to help library.",
      answer: "Sure, please navigate to this link.",
    },
  ];

  let w =  hive_front.widget_appearance ? JSON.parse( hive_front.widget_appearance ) : {};

  const defaultAvatar = hive_front.agent_avatar;


  const tabBtnColor = "#1A1A1A";
  const tabBtnColorActive = w.main_color ?? '#0080ff';

  let defaultState = {
    guest_message_form_display: false,
    user_message_form_display: false,
    add_message_btn: false,
    enable_help_articles_on_home: hive_front.home_tab
      ? JSON.parse(hive_front.home_tab).enable_article_list
      : "",
    is_guest_chat:
      hive_front.messaging_tab &&
      JSON.parse(hive_front.messaging_tab.replace(/\\+/g, ""))
        .enable_guest_chat &&
      hive_front.current_user == 0,
  };

  let active_user_id = 0;
  if (hive_front.current_user != "0" || hive_front.current_user != 0) {
    // Handle logged in user
    active_user_id = hive_front.current_user;
    if (homeTabSettings.enable_users_chat_section) {
      defaultState = { ...defaultState, user_message_form_display: false };
      defaultState = { ...defaultState, add_message_btn: true };
      if (homeTabSettings.users_section_type == "user_chat_form") {
        defaultState = {
          ...defaultState,
          user_message_form_display: true,
          add_message_btn: false,
        };
      }
    }
  } else {
    //Handle Guest
    if (hive_front.hs_guest != "") {
      active_user_id = `-${hive_front.hs_guest}`;
    }
    if (homeTabSettings.enable_guest_chat) {
      defaultState = { ...defaultState, guest_message_form_display: true };
    }
  }
  if (homeTabSettings.enable_guest_chat) {
    if (
      !homeTabSettings.enable_guest_chat &&
      homeTabSettings.enable_users_chat_section
    ) {
      defaultState = { ...defaultState, guest_message_form_display: false };
    }
    if (homeTabSettings.guest_section_type == "guest_chat_button") {
      defaultState = {
        ...defaultState,
        guest_message_form_display: false,
        add_message_btn: true,
      };
    }
  }

  let defaultFormStatus = active_user_id == 0 ? true : false;
  defaultFormStatus = false;

  let defaultAddMessageBtnStatus = active_user_id == 0 ? false : true;
  defaultAddMessageBtnStatus = true;

  const hiveBotLocalKey = "hive_bot_chats";

  // localStorage.removeItem(hiveBotLocalKey);

  // #region Preview States
  const [preview, setPreview] = useState(false);

  // home, messages, help, news
  const [tab, setTab] = useState("home"); // home, messages, help, news, ai
  const [intro, setIntro] = useState(true);
  const [form, setForm] = useState(defaultState.guest_message_form_display);
  const [guestForm, setGuestForm] = useState(
    defaultState.guest_message_form_display
  );
  // User Message Form
  const [messageForm, setMessageForm] = useState(
    defaultState.user_message_form_display
  ); // User Message Form
  const [addMessageBtn, setAddMessageBtn] = useState(
    defaultState.add_message_btn
  );
  const [helpDisplay, setHelpDisplay] = useState(
    defaultState.enable_help_articles_on_home
  );

  const [faq, setFaq] = useState(false);
  const [team, setTeam] = useState(true);
  const [conversation, setConversation] = useState(false);

  const [aiMessageForm, setAiMessageForm] = useState(false);
  const [backBtn, setBackBtn] = useState(false);
  const [messageList, setMessageList] = useState(false);
  const [singleChat, setSingleChat] = useState(false);
  const [activeMessage, setActiveMessage] = useState(0);

  const [articleSearchForm, setArticleSearchForm] = useState(
    defaultState.enable_help_articles_on_home
  );
  const [articleList, setArticleList] = useState(false);
  const [headTitleDisplay, setHeadTitleDisplay] = useState(true);
  const [usersChat, setUsersChat] = useState([]);
  const [chat, setChat] = useState([]);
  const [activeCustomer, setActiveCustomer] = useState(0); // [customer, setActiveCustomer]
  //const [message, setMessage] = useState("");
  const [totalUnread, setTotalUnread] = useState(9);

  let defaultFilter = {
    status: "",
    agent_id: "",
    customer_id: active_user_id,
    secret_content: hive_front.hs_guest,
    count: "10",
    current_page: "1",
  };

  let chat_API_URL = `${hive_front.site_url}/wp-json/hivesupport/v1/chat`;
  const AiChatBotName = "Hive Bot";

  const [filter, setFilter] = useState(defaultFilter);

  // handle in later release
  const [chatCloseBtn, setChatCloseBtn] = useState(false);
  const [newsTab, setNewsTab] = useState(false);
  // #endregion Preview States

  // Data states

  const replyCount = useRef(hive_front.total_reply_count);
  const lasActiveId = useRef(0);
  const lastArticles = useRef([]);

  const isGuest = hive_front.current_user == 0 ? true : false;
  const [guest, setGuest] = useState(isGuest);

  const [activeMessageID, setActiveMessageID] = useState(0);
  const [currentUserId, setCurrentUserId] = useState(active_user_id);
  const [faqs, setFaqs] = useState([$faqs]);

  const [conversations, setConversations] = useState([]); //$conversations
  const [aiconversations, setAiConversations] = useState([]);

  const [headTitle, setHeadTitle] = useState("");
  const [messageCount, setMessageCount] = useState(0);
  // const hasNewMessage = useRef(false);
  const [hasNewMessage, setHasNewMessage] = useState(false);

  /**
   * first state: intro, form
   * second state: intro, faq, message form
   * third form: team, conversation, message form
   * @returns
   */
  /***
   * Home: intro, form
   */
  // #region Event Handlers

  const handleGoToHome = () => {
    setTab("home");
    setHeadTitle("");
    // setPreview(true);
    setIntro(true);

    // homeTabSettings

    // Handle Guest
    if (currentUserId == 0) {
      setForm(true);
      setAddMessageBtn(false);
    } else {
      // Handle Logged in user
      setAddMessageBtn(true);
      setForm(false);
    }

    setAiMessageForm(false);
    // setForm(true);

    setMessageForm(false);
    setBackBtn(false);
    // setChatCloseBtn(false);
    setMessageList(false);
    setActiveMessage(0);
    // setAddMessageBtn(true);
    setArticleSearchForm(defaultState.enable_help_articles_on_home);

    setFaq(false);
    setTeam(true);
    setConversation(false);
  };
  const handleGoToMessages = () => {
    setTab("messages");
    setHeadTitle(
      messagingTabSettings.message_top_bar_title
        ? messagingTabSettings.message_top_bar_title
        : "Messaging"
    );
    setPreview(true);
    setIntro(false);
    setGuestForm(false);
    setForm(false);

    setFaq(false);
    setTeam(false);
    setConversation(false);
    setMessageForm(false);
    setBackBtn(false);
    setChatCloseBtn(false);
    setMessageList(true);
    setActiveMessage(0);
    setArticleSearchForm(false);
    setArticleList(false);
    setAddMessageBtn(true);
    setAiMessageForm(false);
  };
  // handleGoToMessages();

  const handleGoToHelp = () => {
    setTab("help");
    setHeadTitle(
      helpTabSettings.help_top_bar_title
        ? helpTabSettings.help_top_bar_title
        : "Help"
    );

    // Get the help Articles
    // getTheArticles();

    setPreview(true);
    setIntro(false);
    setGuestForm(false);
    setForm(false);
    setFaq(false);
    setTeam(false);
    setConversation(false);
    setMessageForm(false);
    setBackBtn(false);
    setChatCloseBtn(false);
    setMessageList(false);
    setActiveMessage(0);
    setArticleSearchForm(true);
    setArticleList(true);
    setAiMessageForm(false);
  };
  const handleGoToAi = () => {
    setTab("ai");
    setHeadTitle(
      aiTabSettings.ai_top_bar_title
        ? aiTabSettings.ai_top_bar_title
        : "AI Chat"
    );
    setPreview(true);
    setConversation(true);
    setIntro(false);
    setGuestForm(false);
    setForm(false);
    setFaq(false);
    setTeam(false);
    setMessageForm(false);
    setBackBtn(false);
    setChatCloseBtn(false);
    setMessageList(false);
    setActiveMessage(0);
    setArticleSearchForm(false);
    setArticleList(false);
    // setAddMessageBtn(true);
    setAddMessageBtn(false);
    setAiMessageForm(true);
  };

  function hsAddArgInAPI_URL(filterState, ticket_API_URL) {
    let newApiUrl = ticket_API_URL;
    let params = filterState;
    let queryParams = [];
    for (let key in params) {
      if (params[key] !== "") {
        queryParams.push(`${key}=${encodeURIComponent(params[key])}`);
      }
    }
    if (queryParams.length > 0) {
      newApiUrl += "?" + queryParams.join("&");
    }
    return newApiUrl;
  }

  const fetchChatsAsync = async () => {
    const newAPIUrl = hsAddArgInAPI_URL(filter, chat_API_URL);

    try {
      const request = await fetch(newAPIUrl);
      const response = await request.json();
      if (response.success) {
        setChat(response.data.chats);
      }
    } catch (error) {}
  };

  const getUsersChats = () => {
    fetchChatsAsync();
  };

  const handlePreview = () => {
    setPreview(false);
  };
  const handleOpenPreview = () => {
    setPreview(!preview);
  };
  const handleTabChange = (tab) => {
    setTab(tab);
    if (tab == "home") {
      handleGoToHome();
    }
    if (tab == "messages") {
      handleGoToMessages();
    }
    if (tab == "help") {
      handleGoToHelp();
    }
    if (tab == "ai") {
      handleGoToAi();
    }
  };

  const handleAddNewMessage = () => {
    setMessageForm(true);
    // setFaq(true);
    setMessageList(false);
    setBackBtn(true);
    setAddMessageBtn(false);
    setArticleSearchForm(false);
  };

  const handleSyncingMessageList = () => {
    fetchChatsAsync();
  };

  const handleBackToTopLevel = () => {
    // setTab('home');
    setConversations([]);
    setActiveMessageID(0);
    setPreview(true);
    setIntro(false);
    setForm(false);
    setFaq(false);
    setTeam(false);
    setConversation(false);
    setMessageForm(false);
    setBackBtn(false);
    setChatCloseBtn(false);
    setMessageList(true);
    setActiveMessage(0);
    setAddMessageBtn(true);
  };

  const isHiveStaffAgent = (id, staffs) => {
    let isAgent = false;
    for (let key in staffs) {
      if (staffs.hasOwnProperty(key) && key == id) {
        isAgent = true;
        return isAgent;
      }
    }
    return isAgent;
  };

  function customDateFormat(inputDate) {
    return moment.tz(inputDate, hive_front.time_zone).fromNow();
  }

  const fetchSingleChatDataUpdateWrapper = () => {
    fetchSingleChatDataUpdate();
  };

  const handleUpdateConversationUpdate = (getConversation, staffs) => {

    let newConversations = [];
    getConversation.map((conversation, index) => {
      let newConv = conversation;
      let isStaff = true;
      isStaff = isHiveStaffAgent(conversation.person_id, staffs);
      if (isStaff) {
        newConv.person_type = "agent";
      } else {
        newConv.person_type = "customer";
      }
      let thisTime = customDateFormat(conversation.created_at);
      newConv.time = thisTime;
      newConversations.push(newConv);
    });

    setHasNewMessage(true);
    setConversations(newConversations);
  };

  // Main function to fetch single chat -- single_chat
  const fetchSingleChatDataUpdate = async () => {
    let theActiveId;

    if (activeMessageID == 0) {
      theActiveId = lasActiveId.current;
      // setConversations([]);
      // return;
    } else {
      theActiveId = activeMessageID;
    }

    const request = await fetch(
      `${hive_front.site_url}/wp-json/hivesupport/v1/chat/${theActiveId}`
    );
    const response = await request.json();
    if (response.success) {

      handleUpdateConversationUpdate(
        response.data.message_replies,
        response.data.agents_admins
      );
    }
  };

  const handleUpdateConversation = (getConversation, staffs) => {

    let newConversations = [];
    getConversation.map((conversation, index) => {
      let newConv = conversation;

      let isStaff = true;

      isStaff = isHiveStaffAgent(conversation.person_id, staffs);

      if (isStaff) {
        newConv.person_type = "agent";
      } else {
        newConv.person_type = "customer";
      }

      let thisTime = customDateFormat(conversation.created_at);
      newConv.time = thisTime;

      newConversations.push(newConv);
    });

    hiveMessageCount = newConversations.length;

    setConversations(newConversations);
  };

  // Main function to fetch single chat -- single_chat
  const fetchSingleChatData = async () => {

    if (activeMessageID == 0) {
      return;
    }

    const request = await fetch(
      `${hive_front.site_url}/wp-json/hivesupport/v1/chat/${activeMessageID}`
    );
    const response = await request.json();
    if (response.success) {

      handleUpdateConversation(
        response.data.message_replies,
        response.data.agents_admins
      );
    }

  };

  const getSingleChat = () => {
    fetchSingleChatData();
  };

  const handleViewConversation = () => {
    getSingleChat();
  };

  const handleViewSingleMessage = (message) => {
    setActiveMessageID(message.id);
    lasActiveId.current = message.id;

    setHasNewMessage(false);

    setConversation(true);
    setMessageForm(true);
    setFaq(false);
    setMessageList(false);
    setBackBtn(true);
    setAddMessageBtn(false);

    //
    const formdata = new FormData();
    formdata.append( "action", 'hs_add_seen_status' );
    formdata.append("chat_id", message.id );
    formdata.append("chat_user_key", 'customer_seen_status' );

    const request = fetch(hive_front.ajaxurl, {
        method: "POST",
        body: formdata,
    });


  };

  const handleViewSingleArticle = () => {
    // setArticleSearchForm(false);
    // setTab('home');
    // setPreview(true);
    // setIntro(false);
    // setForm(false);
    // setFaq(false);
    // setTeam(false);
    // setConversation(false);
    // setMessageForm(false);
    // setBackBtn(false);
    // setChatCloseBtn(false);
    // setMessageList(true);
    // setActiveMessage(0);
  };

  // #region Component
  const Intro = () => {
    let title = __( "Hi'there", "hive-support" );
    if (homeTabSettings.chat_window_home_title != "") {
      title = homeTabSettings.chat_window_home_title;
    }
    let subTitle = __( "How can we help?", "hive-support" );
    if (homeTabSettings.chat_window_home_subtitle != "") {
      subTitle = homeTabSettings.chat_window_home_subtitle;
    }

    let w = hive_front.widget_appearance ? JSON.parse( hive_front.widget_appearance ) : {};

    let style = {
      backgroundColor: w.main_color,
      color: w.main_text_color,
    }

    let colorStyle = {
      color: w.main_text_color,
    }

    return (
      
      <div
        className="chatContact__contents__header__main pb-5 text-center hs-widget--intro hs-bg--primary"
        id="chatContact__main"
        style={style}
      >
        {/* <span className="chatContact__contents__header__say"><img src={`${hive_front.plugin_url}/assets/livechat/img/chat/wave_emoji.png`} alt="" /></span> */}
        <h6 className="chatContact__contents__header__title mb-3 hs-intro--title" style={colorStyle}>
          {title}
        </h6>
        <p className="chatContact__contents__header__para mt-2 hs-intro-sub--title" style={colorStyle}>
          {subTitle}
        </p>
      </div>
    );
  };
  const Team = () => {
    let w = hive_front.widget_appearance ? JSON.parse( hive_front.widget_appearance ) : {};

    let style = {
      backgroundColor: w.main_color,
      color: w.main_text_color ?? "#ffffff",
    }
    let colorStyle = {
      color: w.main_text_color ?? "#ffffff",
    }
    return (
      <div
        className="chatContact__contents__header__team hs-widget--team hs-bg--primary"
        id="chatContact__team"
        style={style}
      >
        <div className="chatContact__contents__header__team__flex">
          <div className="chatContact__contents__header__team__author">
            {homeTabSettings.agent_media?.map((item) => (
              <a
                href="javascript:void(0)"
                className="chatContact__contents__header__team__author__item"
              >
                <img width="40" src={item.filepath} />
              </a>
            ))}
          </div>
          <div className="chatContact__contents__header__team__contents">
            <h5 className="chatContact__contents__header__team__name">
              <a className="hs-text-white" style={colorStyle}>
                {homeTabSettings.position_title != ""
                  ? homeTabSettings.position_title
                  : ""}
              </a>
            </h5>
            {/* <p className="chatContact__contents__header__team__activity mt-1">Active recently</p> */}
          </div>
        </div>
      </div>
    );
  };
  
  const ChatBoxHeader = () => {

    let w = hive_front.widget_appearance ? JSON.parse( hive_front.widget_appearance ) : {};

    let style = {
      backgroundColor: w.main_color,
      color: w.main_text_color ?? '#ffffff',
    }

    let colorStyle = {
      color: w.main_text_color ?? "#ffffff",
    }

    return (
      <div className="chatContact__contents__header" style={style}>
        <div className="chatContact__contents__header__close w-100">
          <div className="ml--40">
            {backBtn && (
              <div
                className="rotate--180 hs-back-button cursor--pointer"
                onClick={handleBackToTopLevel}
              >
                <BackIconTop />
              </div>
            )}
          </div>
          {headTitleDisplay && (
            <div className="chatContact__contents__head__title hs-text-white">
              {headTitle}
            </div>
          )}
          <div className="close--icon">
            <p
              className="chatContact__contents__header__close__icon close_chat"
              onClick={handlePreview}
              style={colorStyle}
            >
              <i className="material-symbols-outlined">{__( "remove", "hive-support" )}</i>
            </p>
            {chatCloseBtn && (
              <p className="chatContact__contents__header__close__icon close_chat" style={colorStyle}>
                <i className="material-symbols-outlined">{__( "close", "hive-support" )}</i>
              </p>
            )}
          </div>
        </div>
      </div>
    );
  };
  const ChatBoxForm = () => {
    return (
      <div
        className="chatContact__contents__inner__form custom_form"
        id="chatContact__form"
      >
        <form action="#">
          <div className="row g-3">
            <div className="col-sm-12">
              <div className="single_input">
                <input
                  type="text"
                  name="inputfield"
                  className="form--control radius-10"
                  placeholder="Enter Name*"
                />
              </div>
            </div>
            <div className="col-sm-12">
              <div className="single_input">
                <input
                  type="text"
                  name="inputfield"
                  className="form--control radius-10"
                  placeholder="Enter Email*"
                />
              </div>
            </div>
            <div className="col-sm-12">
              <div className="single_input">
                <textarea
                  className="form--control radius-10"
                  name="message"
                  cols="30"
                  rows="2"
                  placeholder="Your Message..."
                ></textarea>
              </div>
            </div>
            <div className="col-sm-12">
              <div className="btn-wrapper" id="form_infoSubmit">
                <button type="button" className="submit_btn w-100 radius-10">
                {__( "Submit", "hive-support" )}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  };

  const ChatBoxFaq = () => {
    if (!faq) return;

    if (!(Array.isArray(faqs) && faqs.length > 0)) return;

    return (
      <div
        className="chatContact__contents__inner__faq d-noneX"
        id="chatContact__faq"
      >
        <div className="chatContact__contents__inner__faq__flex">
          {faqs.map((faq, i) => {
            return (
              <p
                className="chatContact__contents__inner__faq__item findFaq"
                data-index={i}
                data-answer={faq.answer}
              >
                {faq.question}
              </p>
            );
          })}
        </div>
      </div>
    );
  };

  function hsFormatDate(inputDate) {
    const date = new Date(inputDate);

    // Check if the date is valid
    if (isNaN(date.getDate())) {
      return inputDate; // Return empty string if not a valid date
    }

    // Get month, day, and year
    const month = date.toLocaleString("default", { month: "short" });
    const day = date.getDate();
    const year = date.getFullYear();

    // Format the date as desired
    const formattedDate = `${month} ${day} ${year}`;

    return formattedDate;
  }
  const OwnChat = ({ singleMessage }) => {
    const messageContent = singleMessage.content;
    const time = hsFormatDate(singleMessage.time);

    let w = hive_front.widget_appearance ? JSON.parse( hive_front.widget_appearance ) : {};

    let style = {
      backgroundColor: w.visitor_message_color,
      color: w.visitor_text_color,
    }

    return (
      <div
        className="chatContact__contents__inner__chat__item hs_own_chat_box_front"
        data-time={time}
      >
        <div className="chatReply_content_inner">
          <p className="chatContact__contents__inner__chat__item__para hs_front_chat__message" style={style}>
            
            {" "}
            {messageContent}
          </p>
          {time && (
            <p className="chatContact__contents__inner__chat__item__para hs_front_chat__name">
              {" "}
              {time && `${time}`}
            </p>
          )}
        </div>
      </div>
    );
  };
  const OthersChat = ({ singleMessage, image = defaultAvatar }) => {
    const name = singleMessage.person_name;
    const time = hsFormatDate(singleMessage.time);
    const messageContent = singleMessage.content;

    let w = hive_front.widget_appearance ? JSON.parse( hive_front.widget_appearance ) : {};

    let style = {
      backgroundColor: w.agent_message_color,
      color: w.agent_text_color,
    }

    return (
      <div
        className="chatContact__contents__inner__chat__item chatReply hs_front_chat_reply_agent"
        data-name={name}
        data-time={time}
      >
        <span className="chatReply__img">
          <img src={singleMessage.person_pic ?? image} alt="chat" />
        </span>
        <div className="chatReply_content_inner">
          <p className="chatContact__contents__inner__chat__item__para hs_front_chat__message" style={style}>
            {" "}
            {
              messageContent == 'thinking' ? <span className="ai-thinking-loader"></span> : <ReactMarkdown>{messageContent}</ReactMarkdown>
            }
          </p>
          <p className="chatContact__contents__inner__chat__item__para hs_front_chat__name">
            {" "}
            {name} {time && `(${time})`}
          </p>
        </div>
      </div>
    );
  };

  const IntroAIChat = ({  image = defaultAvatar }) => {

    const name = 'Hive Bot';
    let time = '';
    
    const messageContent = aiTabSettings.ai_intro_msg ? aiTabSettings.ai_intro_msg: "Hi👋 How We could Help You?";
    const preSetQuestions = aiTabSettings.pre_set_questions ? aiTabSettings.pre_set_questions : "";



    let w = hive_front.widget_appearance ? JSON.parse( hive_front.widget_appearance ) : {};

    let style = {
      backgroundColor: w.agent_message_color,
      color: w.agent_text_color,
    }

    
    let currTime = new Date();
     time = currTime.getHours() + ":" + currTime.getMinutes();
    let localChats = localStorage.getItem(hiveBotLocalKey);
    const AiSettingsErrorMessage = __( "Ai chat error! Please try again later", "hive-support" );

    let prevAiChat;
    if (localChats) {
      prevAiChat = JSON.parse(localChats);
      // setConversations(prevAiChat);
    } else {
      localStorage.setItem(hiveBotLocalKey, JSON.stringify([]));
      prevAiChat = [];
    }


    const addNewChat = async (e, query) => {
      e.preventDefault();

      // const currTime = new Date();
      const formdata = new FormData();
      formdata.append("action", "hs_ai_chat_send_message");
      formdata.append("chat_title", query);
      formdata.append("my_text", "Hye, Cute pie!");

      // Add the user Message to the list first

      const chatItem = {
        id: 0,
        message_id: 0,
        person_id: 0,
        content: query,
        media_urls: "",
        created_at: time,
        person_name: "Me",
        person_type: "customer",
        time: time,
      };
      prevAiChat = [...prevAiChat, chatItem];
      setAiConversations(prevAiChat);

      if (hive_front.open_ai_ok == "no") {
        const AiChatItemError = {
          id: 0,
          message_id: 0,
          person_id: 0,
          content: AiSettingsErrorMessage,
          media_urls: "",
          created_at: time,
          person_name: AiChatBotName,
          person_type: "agent",
          time: time,
        };
        prevAiChat = [...prevAiChat, AiChatItemError];
        setAiConversations(prevAiChat);
        return;
      }

      const AiChatItem = {
        id: 0,
        message_id: 0,
        person_id: 0,
        content: "thinking",
        media_urls: "",
        created_at: time,
        person_name: AiChatBotName,
        person_type: "agent",
        time: time,
      };
      prevAiChat = [...prevAiChat, AiChatItem];
      setAiConversations(prevAiChat);

      try {
        const request = await fetch(hive_front.ajaxurl, {
          method: "POST",
          body: formdata,
        });

        const response = await request.json();

        if (response.success) {
          // console.log(response.data);

          const aiResponse = JSON.parse(response.data.response);
          const AiMessage = aiResponse.message?.content;

          const AiChatItem = {
            id: 0,
            message_id: 0,
            person_id: 0,
            content: AiMessage,
            media_urls: "",
            created_at: time,
            person_name: AiChatBotName,
            person_type: "agent",
            time: time,
          };
          const updatedPrevAiChat = prevAiChat.slice(0, -1);
          prevAiChat = [...updatedPrevAiChat, AiChatItem];
          setAiConversations(prevAiChat);

          localStorage.setItem(hiveBotLocalKey, JSON.stringify(prevAiChat));
        }
      } catch (err) {
        console.log(err);
      }
    };

    const submitFaqQuestion =  (e, query) => {
      addNewChat(e, query);       
    };



    return (
      <>
      <div
        className="chatContact__contents__inner__chat__item chatReply hs_front_chat_reply_agent"
        data-name={name}
        data-time={time}
      >
        <span className="chatReply__img">
          <img src={image} alt="chat" />
        </span>
        <div className="chatReply_content_inner">
          <p className="chatContact__contents__inner__chat__item__para hs_front_chat__message" style={style}>
            {" "}
            {
               messageContent == 'thinking' ? <span className="ai-thinking-loader"></span> : messageContent
            }
          </p>
          <p className="chatContact__contents__inner__chat__item__para hs_front_chat__name">
            {" "}
            {name} {time && `(${time})`}
          </p>
          <div class="hs-ai-chat-faq-items">
            {
              preSetQuestions && preSetQuestions.map((item, index) => {
                return(
                  item.value && <span className="hs-ai-chat-faq-item" onClick={ (e) =>submitFaqQuestion(e, item.value ) } key={index}>{item.value}</span>
                )
              })
            }
            
          </div>
        </div>

      </div>
      
      </>

    );
  };

  const Conversations = () => {
    if (!conversation) return;
    if (!(Array.isArray(conversations) && conversations.length > 0)) return;

    // Make chat to display from bottom in recent conversations
    const chatContainerRef = useRef(null); // useRef

    useEffect(() => {
      // Scroll to the bottom when messages change
      if (chatContainerRef.current) {
        chatContainerRef.current.scrollTop =
          chatContainerRef.current.scrollHeight;
      }
    }, [conversations]);

    return (
      <div
        className="chatContact__contents__inner__chat "
        id="chatContact__chat" ref={chatContainerRef}
      >
        <div
          className="chatContact__contents__inner__chat_box"
          ref={chatContainerRef}
        >
          {conversations.map((singleMessage, index) => (
            <React.Fragment key={index}>
              {singleMessage.person_type === "customer" ? (
                <OwnChat singleMessage={singleMessage} />
              ) : (
                <OthersChat singleMessage={singleMessage} />
              )}
            </React.Fragment>
          ))}

        </div>
      </div>
    );
  };
  const ConversationsAi = () => {
    //if (!conversation) return;
    //if (!(Array.isArray(aiconversations) && aiconversations.length > 0)) return;

    // Make chat to display from bottom in recent conversations
    const chatContainerRef = useRef(null); // useRef

    useEffect(() => {

      // Scroll to the bottom when messages change
      if (chatContainerRef.current) {
       chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
      }
    }, [aiconversations]);

    let w = hive_front.widget_appearance ? JSON.parse( hive_front.widget_appearance ) : {};
    let avImage = w.aichat_media && w.aichat_media.length > 0 ? w.aichat_media[0].filepath : hive_front.agent_avatar;

    let singleMessage = {
      content: 'How we can help you?',
      time: '',
      person_name: ''
    }
    return (
      <div
        className="chatContact__contents__inner__chat "
        id="chatContact__chat" ref={chatContainerRef}
      >
        <div
          className="chatContact__contents__inner__chat_box"
          ref={chatContainerRef}
        >
          
          { !aiconversations.length && <IntroAIChat image={avImage} /> }
          
          {aiconversations.map((singleMessage, index) => (
            <React.Fragment key={index}>
              {singleMessage.person_type === "customer" ? (
                <OwnChat singleMessage={singleMessage} />
              ) : (
                <OthersChat singleMessage={singleMessage} image={avImage} />
              )}
            </React.Fragment>
          ))}
        </div>

      </div>
    );
  };
  const ChatBoxContent = () => {
    if (!(conversation || faq)) return;
    return (
      <div className="chatContact__contents__inner" id="chatContact__inner">
        <ChatBoxFaq />
        <Conversations />
      </div>
    );
  };

  const ChatBoxAiContent = () => {
    if (!(conversation || faq)) return;

    return (
      <div className="chatContact__contents__inner" id="chatContact__inner">
        <ConversationsAi />
      </div>
    );
  };
  // #endregion Component

  // #region Icons
  const HomeIcon = () => {
    return (
      <>
        <svg
          width="24"
          height="24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            className="home_svg__stroke"
            d="M2.85 9.35c0-.423.218-.85.635-1.143l7.496-5.172h.001a1.84 1.84 0 012.036 0s0 0 0 0l7.495 5.17.002.002c.417.293.635.72.635 1.142V19.7c0 .73-.676 1.45-1.65 1.45h-15c-.974 0-1.65-.72-1.65-1.45V9.35z"
            stroke={tab == "home" ? tabBtnColorActive : tabBtnColor}
            strokeWidth="1.7"
          ></path>
          <path
            className="home_svg__stroke"
            d="M17.25 15A7.855 7.855 0 0112 17.002 7.855 7.855 0 016.75 15"
            stroke={tab == "home" ? tabBtnColorActive : tabBtnColor}
            strokeWidth="1.7"
            strokeLinecap="round"
          ></path>
        </svg>
      </>
    );
  };
  const ChatIcon = () => {
    return (
      <svg
        width="24"
        height="24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask id="messages-active_svg__a" fill="#fff">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22 5a3 3 0 00-3-3H5a3 3 0 00-3 3v10a3 3 0 003 3h10.558l3.883 3.87c.946.942 2.559.272 2.559-1.063V5zm-4.15 2.85A.85.85 0 0017 7H7a.85.85 0 000 1.7h10c.47 0 .85-.38.85-.85zm-5 4A.85.85 0 0012 11H7a.85.85 0 000 1.7h5c.47 0 .85-.38.85-.85z"
          ></path>
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22 5a3 3 0 00-3-3H5a3 3 0 00-3 3v10a3 3 0 003 3h10.558l3.883 3.87c.946.942 2.559.272 2.559-1.063V5zm-4.15 2.85A.85.85 0 0017 7H7a.85.85 0 000 1.7h10c.47 0 .85-.38.85-.85zm-5 4A.85.85 0 0012 11H7a.85.85 0 000 1.7h5c.47 0 .85-.38.85-.85z"
          fill={tab == "messages" ? tabBtnColorActive : tabBtnColor}
        ></path>
        <path
          d="M15.558 18v-1.7h.702l.498.496-1.2 1.204zm3.883 3.87l1.2-1.205-1.2 1.204zM19 .3A4.7 4.7 0 0123.7 5h-3.4A1.3 1.3 0 0019 3.7V.3zM5 .3h14v3.4H5V.3zM.3 5A4.7 4.7 0 015 .3v3.4A1.3 1.3 0 003.7 5H.3zm0 10V5h3.4v10H.3zM5 19.7A4.7 4.7 0 01.3 15h3.4A1.3 1.3 0 005 16.3v3.4zm10.558 0H5v-3.4h10.558v3.4zm2.683 3.374l-3.883-3.87 2.4-2.408 3.883 3.87-2.4 2.408zm5.459-2.267c0 2.848-3.441 4.277-5.459 2.267l2.4-2.409a.228.228 0 00-.218-.043.228.228 0 00-.123.185h3.4zm0-4.307v4.307h-3.4V16.5h3.4zm0-2.543V16.5h-3.4v-2.543h3.4zM23.7 5v8.957h-3.4V5h3.4zm-6.7.3a2.55 2.55 0 012.55 2.55h-3.4c0 .47.38.85.85.85V5.3zm-10 0h10v3.4H7V5.3zM4.45 7.85A2.55 2.55 0 017 5.3v3.4c.47 0 .85-.38.85-.85h-3.4zM7 10.4a2.55 2.55 0 01-2.55-2.55h3.4A.85.85 0 007 7v3.4zm10 0H7V7h10v3.4zm2.55-2.55A2.55 2.55 0 0117 10.4V7a.85.85 0 00-.85.85h3.4zM12 9.3a2.55 2.55 0 012.55 2.55h-3.4c0 .47.38.85.85.85V9.3zm-5 0h5v3.4H7V9.3zm-2.55 2.55A2.55 2.55 0 017 9.3v3.4c.47 0 .85-.38.85-.85h-3.4zM7 14.4a2.55 2.55 0 01-2.55-2.55h3.4A.85.85 0 007 11v3.4zm5 0H7V11h5v3.4zm2.55-2.55A2.55 2.55 0 0112 14.4V11a.85.85 0 00-.85.85h3.4z"
          fill={tab == "messages" ? tabBtnColorActive : tabBtnColor}
          mask="url(#messages-active_svg__a)"
        ></path>
      </svg>
    );
  };
  const ChatIcon2 = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
      >
        <g
          fill={tab == "messages" ? tabBtnColorActive : tabBtnColor}
          clipPath="url(#a)"
        >
          <path d="M2.768 18.719a4.668 4.668 0 0 1-2.296-.603.723.723 0 0 1-.288-1.013c.725-1.16.987-2.576.655-3.908C.495 11.815-.003 10.651 0 9.19.013 4.06 4.282-.098 9.406.002c4.949.1 9.027 4.26 9.027 9.21 0 6.465-6.775 11.004-12.757 8.508-.824.647-1.86.999-2.908.999Zm-.975-1.579c1.127.35 2.394.07 3.263-.77a.713.713 0 0 1 .803-.13c5.121 2.449 11.149-1.39 11.149-7.028 0-4.208-3.424-7.7-7.631-7.785-4.336-.086-7.94 3.426-7.951 7.766-.003 1.388.538 2.498.834 3.814a6.362 6.362 0 0 1-.467 4.133Z"></path>
          <path d="M21.232 24a4.734 4.734 0 0 1-2.908-1c-3.181 1.328-6.965.724-9.573-1.529a.713.713 0 0 1 .931-1.079c2.314 1.998 5.702 2.447 8.459 1.13a.713.713 0 0 1 .803.13 3.305 3.305 0 0 0 3.263.77 6.335 6.335 0 0 1-.248-4.892c.41-.968.618-1.996.615-3.056-.004-1.87-.626-3.599-1.798-5.001a.713.713 0 1 1 1.094-.914A9.26 9.26 0 0 1 24 14.47a9.15 9.15 0 0 1-.719 3.594c-.503 1.459-.272 3.02.535 4.32a.723.723 0 0 1-.288 1.013 4.67 4.67 0 0 1-2.296.603ZM9.217 10.375a1.128 1.128 0 1 0 0-2.255 1.128 1.128 0 0 0 0 2.255ZM5.061 10.375a1.128 1.128 0 1 0 0-2.255 1.128 1.128 0 0 0 0 2.255ZM13.373 10.375a1.128 1.128 0 1 0 0-2.255 1.128 1.128 0 0 0 0 2.255Z"></path>
        </g>
        <defs>
          <clipPath id="a">
            <path fill="#0057FF" d="M0 0h24v24H0z"></path>
          </clipPath>
        </defs>
      </svg>
    );
  };
  const HelpIcon = () => {
    return (
      <svg
        width="24"
        height="24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          className="help_svg__stroke help_svg__circle"
          cx="12"
          cy="12"
          r="9.65"
          stroke={tab == "help" ? tabBtnColorActive : tabBtnColor}
          strokeWidth="1.7"
        ></circle>
        <path
          className="help_svg__stroke help_svg__negative"
          d="M9.664 8.576a2.41 2.41 0 114.102 2.39l-1.075 1.104c-.326.322-.765.76-.765 1.544v.364"
          stroke={tab == "help" ? tabBtnColorActive : tabBtnColor}
          strokeWidth="1.7"
          strokeLinecap="round"
        ></path>
        <circle
          className="help_svg__fill help_svg__negative"
          cx="11.927"
          cy="16.884"
          r="0.884"
          fill={tab == "help" ? tabBtnColorActive : tabBtnColor}
        ></circle>
      </svg>
    );
  };
  const NewsIcon = () => {
    return (
      <svg
        width="24"
        height="24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className="news_svg__stroke"
          d="M20 4a6.979 6.979 0 012.101 5c0 1.959-.804 3.73-2.101 5"
          stroke={tab == "news" ? tabBtnColorActive : tabBtnColor}
          strokeWidth="1.7"
          strokeLinecap="round"
        ></path>
        <mask id="news_svg__a" fill="#fff">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.5 14h.718l5.231 3.452A1 1 0 0017 16.617V1.858a1 1 0 00-1.55-.835L10.937 4H5a5 5 0 00-1.923 9.617l1.967 7.212a2.268 2.268 0 004.456-.597V14z"
          ></path>
        </mask>
        <path
          className="news_svg__fill"
          d="M10.218 14l.936-1.419-.426-.28h-.51V14zM9.5 14v-1.7H7.8V14h1.7zm5.95 3.452l-.937 1.42.936-1.42zm0-16.429l-.937-1.419.936 1.42zM10.937 4v1.7h.51l.426-.28L10.938 4zm-7.86 9.617l1.64-.447-.22-.802-.766-.32-.655 1.57zm1.966 7.212l1.64-.447-1.64.447zm5.174-8.529H9.5v3.4h.718v-3.4zm6.168 3.733l-5.232-3.452L9.28 15.42l5.232 3.452 1.873-2.838zm-1.086.584a.7.7 0 011.085-.584l-1.872 2.838c1.795 1.185 4.187-.103 4.187-2.253h-3.4zm0-14.759v14.76h3.4V1.857h-3.4zm1.085.584a.7.7 0 01-1.085-.584h3.4c0-2.15-2.392-3.438-4.187-2.254l1.873 2.838zm-4.51 2.977l4.51-2.977-1.872-2.838-4.511 2.977 1.872 2.838zM5 5.7h5.938V2.3H5v3.4zM1.7 9A3.3 3.3 0 015 5.7V2.3c-3.7 0-6.7 3-6.7 6.7h3.4zm2.032 3.048A3.301 3.301 0 011.7 9h-3.4a6.701 6.701 0 004.123 6.186l1.309-3.138zm2.952 8.334L4.718 13.17l-3.28.895 1.966 7.211 3.28-.894zm.548.418a.568.568 0 01-.548-.418l-3.28.894A3.968 3.968 0 007.232 24.2v-3.4zm.568-.568a.568.568 0 01-.568.568v3.4a3.968 3.968 0 003.968-3.968H7.8zM7.8 14v6.232h3.4V14H7.8z"
          fill={tab == "news" ? tabBtnColorActive : tabBtnColor}
          mask="url(#news_svg__a)"
        ></path>
      </svg>
    );
  };
  const BackIcon = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M5.42773 4.70898C5.46387 4.85254 5.53809 4.98828 5.65039 5.10059L8.54932 8L5.64893 10.9004C5.31689 11.2324 5.31689 11.7705 5.64893 12.1025C5.98096 12.4336 6.51904 12.4336 6.85107 12.1025L10.3516 8.60059C10.5591 8.39355 10.6367 8.10449 10.585 7.83691C10.5537 7.67578 10.4761 7.52246 10.3516 7.39844L6.85254 3.89941C6.52051 3.56738 5.98242 3.56738 5.65039 3.89941C5.43066 4.11816 5.35645 4.42871 5.42773 4.70898Z"
          fill="#000000"
        ></path>
      </svg>
    );
  };
  const BackIconTop = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M5.42773 4.70898C5.46387 4.85254 5.53809 4.98828 5.65039 5.10059L8.54932 8L5.64893 10.9004C5.31689 11.2324 5.31689 11.7705 5.64893 12.1025C5.98096 12.4336 6.51904 12.4336 6.85107 12.1025L10.3516 8.60059C10.5591 8.39355 10.6367 8.10449 10.585 7.83691C10.5537 7.67578 10.4761 7.52246 10.3516 7.39844L6.85254 3.89941C6.52051 3.56738 5.98242 3.56738 5.65039 3.89941C5.43066 4.11816 5.35645 4.42871 5.42773 4.70898Z"
          fill="#fff"
        ></path>
      </svg>
    );
  };
  const ChatBotIcon = () => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 15C8.80222 15 8.60888 15.0586 8.44443 15.1685C8.27998 15.2784 8.15181 15.4346 8.07612 15.6173C8.00043 15.8 7.98063 16.0011 8.01921 16.1951C8.0578 16.3891 8.15304 16.5673 8.29289 16.7071C8.43275 16.847 8.61093 16.9422 8.80491 16.9808C8.99889 17.0194 9.19996 16.9996 9.38268 16.9239C9.56541 16.8482 9.72159 16.72 9.83147 16.5556C9.94135 16.3911 10 16.1978 10 16C10 15.7348 9.89464 15.4804 9.70711 15.2929C9.51957 15.1054 9.26522 15 9 15ZM2 14C1.73478 14 1.48043 14.1054 1.29289 14.2929C1.10536 14.4804 1 14.7348 1 15V17C1 17.2652 1.10536 17.5196 1.29289 17.7071C1.48043 17.8946 1.73478 18 2 18C2.26522 18 2.51957 17.8946 2.70711 17.7071C2.89464 17.5196 3 17.2652 3 17V15C3 14.7348 2.89464 14.4804 2.70711 14.2929C2.51957 14.1054 2.26522 14 2 14ZM22 14C21.7348 14 21.4804 14.1054 21.2929 14.2929C21.1054 14.4804 21 14.7348 21 15V17C21 17.2652 21.1054 17.5196 21.2929 17.7071C21.4804 17.8946 21.7348 18 22 18C22.2652 18 22.5196 17.8946 22.7071 17.7071C22.8946 17.5196 23 17.2652 23 17V15C23 14.7348 22.8946 14.4804 22.7071 14.2929C22.5196 14.1054 22.2652 14 22 14ZM17 7H13V5.72C13.3023 5.54549 13.5536 5.29491 13.7291 4.99317C13.9045 4.69143 13.9979 4.34903 14 4C14 3.46957 13.7893 2.96086 13.4142 2.58579C13.0391 2.21071 12.5304 2 12 2C11.4696 2 10.9609 2.21071 10.5858 2.58579C10.2107 2.96086 10 3.46957 10 4C10.0021 4.34903 10.0955 4.69143 10.2709 4.99317C10.4464 5.29491 10.6977 5.54549 11 5.72V7H7C6.20435 7 5.44129 7.31607 4.87868 7.87868C4.31607 8.44129 4 9.20435 4 10V19C4 19.7956 4.31607 20.5587 4.87868 21.1213C5.44129 21.6839 6.20435 22 7 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V10C20 9.20435 19.6839 8.44129 19.1213 7.87868C18.5587 7.31607 17.7956 7 17 7ZM13.72 9L13.22 11H10.78L10.28 9H13.72ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H7C6.73478 20 6.48043 19.8946 6.29289 19.7071C6.10536 19.5196 6 19.2652 6 19V10C6 9.73478 6.10536 9.48043 6.29289 9.29289C6.48043 9.10536 6.73478 9 7 9H8.22L9 12.24C9.05475 12.4619 9.18385 12.6583 9.36579 12.7966C9.54774 12.9349 9.77157 13.0067 10 13H14C14.2284 13.0067 14.4523 12.9349 14.6342 12.7966C14.8162 12.6583 14.9452 12.4619 15 12.24L15.78 9H17C17.2652 9 17.5196 9.10536 17.7071 9.29289C17.8946 9.48043 18 9.73478 18 10V19ZM15 15C14.8022 15 14.6089 15.0586 14.4444 15.1685C14.28 15.2784 14.1518 15.4346 14.0761 15.6173C14.0004 15.8 13.9806 16.0011 14.0192 16.1951C14.0578 16.3891 14.153 16.5673 14.2929 16.7071C14.4327 16.847 14.6109 16.9422 14.8049 16.9808C14.9989 17.0194 15.2 16.9996 15.3827 16.9239C15.5654 16.8482 15.7216 16.72 15.8315 16.5556C15.9414 16.3911 16 16.1978 16 16C16 15.7348 15.8946 15.4804 15.7071 15.2929C15.5196 15.1054 15.2652 15 15 15Z"
          fill={tab == "ai" ? tabBtnColorActive : tabBtnColor}
        />
      </svg>
    );
  };
  // #endregion Icons

  const MessageForm = () => {
    
    const [message, setMessage] = useState("");
    const handleSetMessage = (message) => {
      setMessage(message);
    };

    const handleViewNewSingleMessage = (id) => {
      handleGoToMessages();

      setActiveMessageID(id);
      // console.log(activeMessageID);
      setActiveMessage(message.id);
      // console.log(message);
      setConversation(true);
      setMessageForm(true);
      setFaq(false);
      setMessageList(false);
      setBackBtn(true);
      setAddMessageBtn(false);
    };

    const addNewChat = async (e) => {
      e.preventDefault();

      const formdata = new FormData();
      formdata.append("action", "hs_add_new_chat");
      formdata.append("chat_title", message);
      formdata.append("customer_id", hive_front.current_user);

      try {
        const request = await fetch(hive_front.ajaxurl, {
          method: "POST",
          body: formdata,
        });
        const response = await request.json();
        if (response.success) {
          
          // For logged in users
          const newChatId = response.data?.is_success;
          setMessage("");
          handleViewNewSingleMessage(newChatId);
          handleSyncingMessageList();
          // fireNotify(`New chat #${newChatId} added successfully`, "success");
        }
      } catch (err) {
        fireNotify(err, "error");
      }
    };

    const addReplyToChat = async (e) => {
      e.preventDefault();
      if (!message) return;
      
      const formdata = new FormData();
      formdata.append("action", "hs_add_chat_reply");
      formdata.append("chat_reply", message);
      formdata.append("chat_id", activeMessageID);
      formdata.append("person_id", hive_front.current_user);

      // formdata.append("response_answer", resanswere);
      try {
        const request = await fetch(hive_front.ajaxurl, {
          method: "POST",
          body: formdata,
        });
        const response = await request.json();
        if (response.success) {
          
          setMessage("");
          fireNotify("Response added successfully", "success");
          fetchSingleChatData();
        }
      } catch (err) {
        fireNotify(err, "error");
      }
    };

    const sendMessage = async (e) => {
      if (activeMessageID == 0 || !activeMessageID) {
        addNewChat(e);
      } else {
        addReplyToChat(e);
      }
    };

    return (
      <div
        className="chatContact__contents__footer chatContact__contents__footer_new"
        id="chatContact__footer"
      >
        <div className="chatContact__contents__footer__input uploadImage">
          <textarea
            className="emoji_show"
            name="message"
            cols="100"
            rows="5"
            placeholder={__( "Write a message...", "hive-support" )}
            onChange={(e) => handleSetMessage(e.target.value)}
          ></textarea>
        </div>
        <div className="chatContact__contents__footer__bottom">
          <div className="chatContact__contents__footer__bottom__left">
            {/* <a href="javascript:void(0)" className="chatContact__contents__footer__icon attachment"><input className="inputTag" type="file" /></a> */}
            {/* <a href="javascript:void(0)" className="chatContact__contents__footer__icon"><i className="material-symbols-outlined emoji_picker">mood</i></a> */}
          </div>
          <div className="chatContact__contents__footer__bottom__right">
            <a
              href="javascript:void(0)"
              className="chatSumbit hs_chat_submit_btn"
              onClick={(e) => sendMessage(e)}
            >
              <i className="material-symbols-outlined">{__( "send", "hive-support" )}</i>
            </a>
          </div>
        </div>
      </div>
    );
  };

  const AIMessageForm = () => {
    const [message, setMessage] = useState("");
    const handleSetMessage = (message) => {
      setMessage(message);
    };
    let currTime = new Date();
    let time = currTime.getHours() + ":" + currTime.getMinutes();
    let localChats = localStorage.getItem(hiveBotLocalKey);
    const AiSettingsErrorMessage = __( "Ai chat error! Please try again later", "hive-support" );

    let prevAiChat;
    if (localChats) {
      prevAiChat = JSON.parse(localChats);
      // setConversations(prevAiChat);
    } else {
      localStorage.setItem(hiveBotLocalKey, JSON.stringify([]));
      prevAiChat = [];
    }

    
    // const handleViewNewSingleMessage = (id) => {
    //   handleGoToMessages();
    //   setActiveMessageID(id);
    //   setActiveMessage(message.id);
    //   setConversation(true);
    //   setMessageForm(true);
    //   setFaq(false);
    //   setMessageList(false);
    //   setBackBtn(true);
    //   setAddMessageBtn(false);
    // };

    const addNewChat = async (e) => {
      e.preventDefault();
      // const currTime = new Date();
      const formdata = new FormData();
      formdata.append("action", "hs_ai_chat_send_message");
      formdata.append("chat_title", message);
      formdata.append("my_text", "Hye, Cute pie!");

      // Add the user Message to the list first

      const chatItem = {
        id: 0,
        message_id: 0,
        person_id: 0,
        content: message,
        media_urls: "",
        created_at: time,
        person_name: "Me",
        person_type: "customer",
        time: time,
      };
      prevAiChat = [...prevAiChat, chatItem];
      setAiConversations(prevAiChat);

      if (hive_front.open_ai_ok == "no") {
        const AiChatItemError = {
          id: 0,
          message_id: 0,
          person_id: 0,
          content: AiSettingsErrorMessage,
          media_urls: "",
          created_at: time,
          person_name: AiChatBotName,
          person_type: "agent",
          time: time,
        };
        prevAiChat = [...prevAiChat, AiChatItemError];
        setAiConversations(prevAiChat);
        return;
      }

      const AiChatItem = {
        id: 0,
        message_id: 0,
        person_id: 0,
        content: "thinking",
        media_urls: "",
        created_at: time,
        person_name: AiChatBotName,
        person_type: "agent",
        time: time,
      };
      prevAiChat = [...prevAiChat, AiChatItem];
      setAiConversations(prevAiChat);

      try {
        const request = await fetch(hive_front.ajaxurl, {
          method: "POST",
          body: formdata,
        });

        const response = await request.json();

        if (response.success) {
          // console.log(response.data);

          const aiResponse = JSON.parse(response.data.response);
          const AiMessage = aiResponse.message?.content;

          const AiChatItem = {
            id: 0,
            message_id: 0,
            person_id: 0,
            content: AiMessage,
            media_urls: "",
            created_at: time,
            person_name: AiChatBotName,
            person_type: "agent",
            time: time,
          };
          const updatedPrevAiChat = prevAiChat.slice(0, -1);
          prevAiChat = [...updatedPrevAiChat, AiChatItem];
          setMessage("");
          setAiConversations(prevAiChat);

          localStorage.setItem(hiveBotLocalKey, JSON.stringify(prevAiChat));
        }

      } catch (err) {
        console.log(err);
      }
    };

    useEffect(() => {
      if (prevAiChat.length > 0 && GetAiInit == 1) {
        //setConversations(prevAiChat);
        setAiConversations(prevAiChat);
        GetAiInit++;
      }
    }, []);


    return (
      <div
        className="chatContact__contents__footer chatContact__contents__footer_new"
        id="chatContact__footer_ai"
      >
        <div className="chatContact__contents__footer__input uploadImage">
          <textarea
            className="emoji_show"
            name="message_ai"
            cols="100"
            rows="5"
            placeholder={
              aiTabSettings.form_placeholder
                ? aiTabSettings.form_placeholder
                : "Enter Message"
            }
            value={message}
            onChange={(e) => handleSetMessage(e.target.value)}
          ></textarea>
        </div>
        <div className="chatContact__contents__footer__bottom">
          <div className="chatContact__contents__footer__bottom__left"></div>
          <div className="chatContact__contents__footer__bottom__right">
            <a
              href="javascript:void(0)"
              className="chatSumbit hs_chat_submit_btn"
              onClick={(e) => addNewChat(e)}
            >
              <i className="material-symbols-outlined">{__( "send", "hive-support" )}</i>
            </a>
          </div>
        </div>
      </div>
    );
  };

  const NavTab = () => {
    const isMsg =
      (enableMessaging && hive_front.current_user > 0) ||
      (enableMessaging && defaultState.is_guest_chat);
    return (
      <div className="chatContact__nav_tab">
        <div className="chatContact__nav_tab_wrapper">
          <div className="hs-tab-row text-center">
            <div className="hs-tab-col">
              <div
                className="hs--tab-icon"
                onClick={() => handleTabChange("home")}
              >
                <HomeIcon />
              </div>
            </div>

            {isMsg && (
              <div className="hs-tab-col">
                <div
                  className="hs--tab-icon hs-message-tab-wrapper"
                  onClick={() => handleTabChange("messages")}
                >
                  {hasNewMessage && (
                    <div className="hs-message-count-wrapper"></div>
                  )}
                  <ChatIcon2 />
                </div>
              </div>
            )}
            {enableAiChat && (
              <div className="hs-tab-col">
                <div
                  className="hs--tab-icon"
                  onClick={() => handleTabChange("ai")}
                >
                  <ChatBotIcon />
                </div>
              </div>
            )}
            {enableHelp && (
              <div className="hs-tab-col">
                <div
                  className="hs--tab-icon"
                  onClick={() => handleTabChange("help")}
                >
                  <HelpIcon />
                </div>
              </div>
            )}
            {newsTab && (
              <div className="hs-tab-col">
                <div
                  className="hs--tab-icon"
                  onClick={() => handleTabChange("news")}
                >
                  <NewsIcon />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const MessageListItem = ({ message }) => {
    const updated_time = customDateFormat(message.updated_at);

    return (
      <div className="hs-message-list-wrapper cursor--pointer">
        <div
          className="hs-message-list-inner d-flex align-items-center p--20"
          onClick={() => handleViewSingleMessage(message)}
        >
          
          <div className="chat-head">
          {message.customer_seen_status == 'no' ? <span className="ticket-watch-status chat-watch-status"></span> : ''}
            <img src={defaultAvatar} alt="Chat Head" />
          </div>
          <div className="chat-content ml--20 mr--20">
            <div
              className="chat--title"
              data-info={`ID: ${message.id},  Agent: ${message.agent_id}, ${
                message.agent_name
              }; Customer: ${message.customer_id}, ${
                message.customer_user_name || message.customer_name
              }`}
            >
              {message.title}
            </div>

            <div className="chat--info d-flex">
              <div className="chat-date">{updated_time}</div>
            </div>
          </div>
          <div className="chat-view ml-auto">
            <BackIcon />
          </div>
        </div>
      </div>
    );
  };

  const [totalReplyCount, setTotalReplyCount] = useState(0);

  const get_current_user_total_reply_count = async () => {
    const formData = new FormData();

    formData.append("action", "get_current_user_total_reply_count");
    formData.append("user_id", hive_front.current_user);
    formData.append("test_data", "prio_test");

    try {
      const request = await fetch(hive_front.ajaxurl, {
        method: "POST",
        body: formData,
      });
      const response = await request.json();
      if (response.success) {

        if (replyCount.current != response.data.total_reply_count) {
          replyCount.current = response.data.total_reply_count;

          fetchSingleChatDataUpdateWrapper();

        }

        // setTotalReplyCount(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const isMsg =
    (enableMessaging && hive_front.current_user > 0) ||
    (enableMessaging && defaultState.is_guest_chat);

  let hsReplyCountSync = isMsg;

  if (hsReplyCountSync) {
    useEffect(() => {
      const intervalId = setInterval(() => {
        get_current_user_total_reply_count();
      }, hsSyncingTimer);
      return () => clearInterval(intervalId);
    }, []);
  }

  const MessageList = () => {
    if (!messageList) return;

    const [totalReplyCount, setTotalReplyCount] = useState(0);
    const replyCount = useRef(0);
    const searchRest = 1 * 500;
    let hsReplyCountSync = true;

    return (
      <div className="hs-message-list Pro-test">
        
        {Array.isArray(chat) &&
          chat.map((message, index) => (
            <MessageListItem key={index} message={message} />
          ))}
        {chat.length == 0 && (
          <div className="text-center p--20">
            {messagingTabSettings.empty_message_title
              ? messagingTabSettings.empty_message_title
              : __( "Your messages will appear here.", "hive-support" )}
          </div>
        )}
      </div>
    );
  };
  const ArticleListItem = ({ article }) => {

    let w = hive_front.widget_appearance ? JSON.parse( hive_front.widget_appearance ) : {};

    let linkStyleColor = {
      color: w.link_color
    }

    return (
      <div className="hs-message-list-wrapper cursor--pointer hs-article-list-wrapper">
        <a href={article.link} target="_blank" style={linkStyleColor}>
          <div
            className="hs-message-list-inner p--20 hs-article-list-inner"
            onClick={handleViewSingleArticle}
          >
            <div className="chat-content mr--20">
              <div className="chat--title">{article.title}</div>
            </div>
            <div className="chat-view ml-auto">
              <BackIcon />
            </div>
          </div>
        </a>
      </div>
    );
  };

  const Articles = ({ articles }) => {
    return (
      <div className="hs-message-list">
        {Array.isArray(articles) &&
          articles.map((article, index) => {
            return <ArticleListItem key={index} article={article} />;
          })}
        {articles.length == 0 && (
          <div className="text-center p--20">
            {helpTabSettings.empty_title
              ? helpTabSettings.empty_title
              : __( "No articles found.", "hive-support" )}
          </div>
        )}
      </div>
    );
  };

  const SearchForm = ({ onSearch, iconClass, setIconClass }) => {
    const [searchString, setSearchString] = useState("");
    const searchRest = 1000;

    const handleChange = (e) => {
      const input = e.target.value;
      setSearchString(input);
      setIconClass("fa-solid fa-spinner fa-spin");

      // Debounce search by waiting 1 second before triggering search
      const timeoutId = setTimeout(() => {
        onSearch(input);
      }, searchRest);

      // Clear previous timeout to prevent multiple searches
      return () => clearTimeout(timeoutId);
    };

    const searchResults = localStorage.getItem(
      "hive_support_pro_search_results"
    );

    if (!searchResults) {
      useEffect(() => {
        onSearch(searchString);
      }, []);
    }


    let w =  hive_front.widget_appearance ? JSON.parse( hive_front.widget_appearance ) : {};

    let style = {
      backgroundColor: w.main_color,
      color: w.main_text_color,
    }


    return (
      <>
        <div
          className={`chatContact__contents__inner__form custom_form search_form_wrapper ${
            tab == "help" ? "pt--0" : ""
          }`}
          id="chatContact__form"
          style={style}
        >
          <form action="#">
            <div className="row g-3">
              <div className="col-sm-12 position-relative">
                <div className="single_input">
                  <input
                    type="text"
                    name="hs_search__article"
                    className="form--control radius-10 hs-search--input"
                    placeholder={homeTabSettings.chat_window_home_search_pholder}
                    value={searchString}
                    onChange={(e) => handleChange(e)}
                  />
                </div>
                <div className="search--icon">
                  <button
                    type="submit"
                    className="hs_search_submit_btn"
                    onClick={(e) => handleChange(e)}
                    style={style}
                  >
                    <i class={iconClass}></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </>
    );
  };
  const SearchResults = ({ results }) => {
    return <Articles articles={results} />;
  };
  const HelpTab = () => {
    let defaultSearchResults = [];
    if (lastArticles.current.length > 0) {
      defaultSearchResults = lastArticles.current;
    }

    // Get the previous search string
    const searchString = localStorage.getItem(
      "hive_support_pro_search_results"
    );
    if (searchString) {
      defaultSearchResults = JSON.parse(searchString);
    }

    const [searchResults, setSearchResults] = useState(defaultSearchResults);
    const [iconClass, setIconClass] = useState("fa-solid fa-magnifying-glass"); // 'fas fa-spinner fa-spin'

    const articleSearchHelper = async (formData) => {
      try {
        const response = await fetch(hive_front.ajaxurl, {
          method: "POST",
          body: formData,
        });
        const result = await response.json();
        if (result.success) {
          
          if (result.data.is_success == "yes") {
            
            setSearchResults(result.data.articles);
            lastArticles.current = result.data.articles;
            setIconClass("fa-solid fa-magnifying-glass");

          }
        }
      } catch (e) {
        console.log(e);
      }
    };

    const handleSearchSubmit = (searchData) => {
      
      const formData = new FormData();
      formData.append("action", "get_the_articles");
      formData.append("post_types", "post,page");
      formData.append("per_page", "7");
      formData.append("search_string", searchData);
      articleSearchHelper(formData);

    };

    const handleSearch = (searchString) => {
      handleSearchSubmit(searchString);
    };

    return (
      <>
        <SearchForm
          onSearch={handleSearch}
          iconClass={iconClass}
          setIconClass={setIconClass}
        />
        <SearchResults results={searchResults} />
      </>
    );
  };

  const ChatWindow = () => {
    const [messageCount, setMessageCount] = useState(0);

    return (
      <div
        className={`chatContact__contents showChat`}
        id="chatContact__contents"
      >
        <div>
          <ChatBoxHeader />
          {team && <Team />}

          {intro && <Intro />}
        </div>
        {/* {team && <Team/>} */}
        {/* {guestForm && <ChatBoxForm/>} */}
        {tab != "ai" && <ChatBoxContent />}
        {tab == "ai" && <ChatBoxAiContent />}
        {messageForm && <MessageForm />}
        <MessageList />
         
        {aiMessageForm && <AIMessageForm />}
        {articleSearchForm && <HelpTab />}
        {/* {helpDisplay && <HelpTab/>} */}
        {addMessageBtn && <AddMessageBtn />}
        <NavTab />
      </div>
    );
  };

  const ChatBtn = () => {
    const ChatIcon = () => {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="30"
          viewBox="0 -960 960 960"
          width="30"
          fill="#fff"
        >
          <path d="M240-400h320v-80H240v80Zm0-120h480v-80H240v80Zm0-120h480v-80H240v80ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z" />
        </svg>
      );
    };
    const CloseIcon = () => {
      return (
        <svg
          width="30"
          height="30"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.601 8.39897C18.269 8.06702 17.7309 8.06702 17.3989 8.39897L12 13.7979L6.60099 8.39897C6.26904 8.06702 5.73086 8.06702 5.39891 8.39897C5.06696 8.73091 5.06696 9.2691 5.39891 9.60105L11.3989 15.601C11.7309 15.933 12.269 15.933 12.601 15.601L18.601 9.60105C18.9329 9.2691 18.9329 8.73091 18.601 8.39897Z"
            fill="white"
          ></path>
        </svg>
      );
    };

    let w = hive_front.widget_appearance ? JSON.parse( hive_front.widget_appearance ) : {};

    let style = {
      backgroundColor: w.main_color,
      color: w.main_text_color,
    }
    return (
      
      <div className={`chatContact__btnWrapper mt-3`}>
        <div
          className="chatContact__btn hs-chat-icon--wrapper"
          onClick={handleOpenPreview}
          style={style}
        >
          {" "}
          {preview ? <CloseIcon /> : <ChatIcon />}{" "}
        </div>
      </div>
    );
  };
  const ChatBtnX = () => {
    if (preview) return;
    return (
      <div className={`chatContact__btnWrapper mt-3`}>
        <div className="chatContact__btn" onClick={handleOpenPreview}>
          <i className="material-symbols-outlined"> {__( "comment", "hive-support" )}</i>{__( "Chat with us", "hive-support" )}{" "}
        </div>
      </div>
    );
  };
  const AddMessageBtn = () => {

    let w = hive_front.widget_appearance ? JSON.parse( hive_front.widget_appearance ) : {};

    let style = {
      backgroundColor: w.main_color,
      color: w.main_text_color,
    }


    return (
      <div className="chatContact__btnWrapper mt-3 hs-new-conversation--btn">
        <div className="chatContact__btn" onClick={handleAddNewMessage} style={style}>
          <i className="material-symbols-outlined">{__( "comment", "hive-support" )}</i>
          {messagingTabSettings.send_btn_title
            ? messagingTabSettings.send_btn_title
            : __( "Send Message", "hive-support" )}
        </div>
      </div>
    );
  };

  const HomeAddMessageBtn = () => {
    return (
      <div className="chatContact__btnWrapper mt-3 hs-new-conversation--btn d-flex justify-content-center">
        <div className="chatContact__btn" onClick={handleAddNewMessage}>
          <i className="material-symbols-outlined">{__( "comment", "hive-support" )}</i>{__( "Send Message", "hive-support" )}
        </div>
      </div>
    );
  };

  // Actions after setting active single chat
  useEffect(() => {
    handleViewConversation();
  }, [activeMessageID]);

  // Actions after getting users chat
  useEffect(() => {
    getUsersChats();
    // getTheArticles();
  }, []);

  // setDefaultState();
  return (
    <>
      <div className="chatContact" id="chatContact">
        {preview ? <ChatWindow /> : ""}
        <ChatBtn />
      </div>
    </>
  );
};

export default ChatBox;
